import { useRef, useEffect } from 'react'


const useInterval = (callback, delay) => {
  const savedCallback = useRef()
  const intervalRef = useRef(null)

  // remember last callback
  useEffect(() => {
    savedCallback.current = callback
  }, [ callback ])

  useEffect(() => {
    const tick = (...args) => savedCallback.current(intervalRef.current, ...args)

    intervalRef.current = setInterval(tick, delay)

    return () => {
      clearInterval(intervalRef.current)
    }
  }, [ delay ])

  return [ intervalRef.current ]
}


export default useInterval
